export const LOADING_VACCINES_EMP = 'LOADING_VACCINES_EMP';
export const GET_VACCINES_EMP = 'GET_VACCINES_EMP';
export const SAVE_LOADING_VACCINES_EMP = 'SAVE_LOADING_VACCINES_EMP';
